module.exports = __webpack_public_path__ + "Icono_Pago-Bco_126px.png";